// The default expiry of the cookie not the authentication token.
// This needs to be slightly longer than the token duration so it
// token remains stored while it's valid.
// This can be overridden in <code>set</code> method.
const DEFAULT_COOKIE_EXPIRY_IN_DAYS = 7

export const COOKIE_STORAGE_SETTINGS = {
  domain: getCookieDomain(),
  expires: DEFAULT_COOKIE_EXPIRY_IN_DAYS,
  secure: true,
  sameSite: 'lax',
}

/**
 * Returns the parent domain name, e.g. localhost, .ftrdev.com or .fortherecord.com
 */
function getCookieDomain(): string | undefined {
  const hostname = window.location.hostname
  if (hostname === 'localhost') {
    return hostname
  }
  return `.${hostname.split('.').slice(-2).join('.')}`
}
